/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_TitleInputs */

const he_home_cta_title = /** @type {(inputs: Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אל תפספסו ירידת מחיר`)
};

const en_home_cta_title = /** @type {(inputs: Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't miss a price drop`)
};

/**
* | output |
* | --- |
* | "Don't miss a price drop" |
*
* @param {Home_Cta_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_cta_title = /** @type {((inputs?: Home_Cta_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_cta_title(inputs)
	return en_home_cta_title(inputs)
});